// 全局
export enum menuKey {
  deal = 'Deal', // 产品
  expert = 'Expert', // 专家
  market = 'Market', // 市场
  account = 'Account', // 个人中心
  organization = 'Organization', // 机构
  investment = 'Investment', // 投资
  absUI = 'ABSUI', // 产品
  dealStaticAnalysis = 'Deal.StaticAnalysis', // 产品基本分析
  dealNoStaticAnalysis = 'Deal.StaticAnalysis.NoStaticAnalysis', // 产品基本分析
  PortfolioList = 'PortfolioList', // 组合管理
  organizationEdit = 'Organization.Edit', // 机构我要编辑
  organizationExpertCertification = 'Organization.ExpertCertification', // 机构专家认证
  negativeWatch = 'NegativeWatch', // 观察名单
  hotSpot = 'CNABS.HotSpot', // 市场热点
  award = 'CNABS.Award', // 投票
  productManagement = 'ProductManagement', // 产品管理
  manage = 'CNABS.Manage', // 后台管理
  help = 'CNABS.Help', // 使用帮助
  home = 'CNABS.HomePage', // 首页
  personCenter = 'PersonCenter', // 个人中心
  aboutUS = 'CNABS.AboutUS', // 关于我们
  web = 'CNABS.AboutUS.Product.Web', // 云平台
  app = 'CNABS.AboutUS.Product.App', // 移动端
  desk = 'CNABS.AboutUS.Product.Desk', // 桌面端
  aboutCompany = 'CNABS.AboutUS.HeYi.CompanyProfile', // 公司简介
  aboutTeam = 'CNABS.AboutUS.HeYi.AboutTeam', // 团队介绍
  contactUs = 'CNABS.AboutUS.HeYi.ContactUs', // 联系我们
  eduction = 'HeyiAcademy', // 和逸学院
  api = 'CNABS.Api', // api
  apiList = 'CNABS.Api.list', // api列表
  apiDetail = 'CNABS.ApiDetail', // api详情
  reits = 'CNABS.REITs' // reits专区
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/config/menuKeyConfig.ts